// extracted by mini-css-extract-plugin
module.exports = {"addNewMemberForm":"addNewMemberForm-2PO6c"};